import { ComponentType, CSSProperties } from 'react';

type Props = {
  intent: 'missing' | 'unsaved';
};

const MESSAGES = {
  missing: 'This field cannot be empty',
  unsaved: 'Unsaved changes',
};

export const Chip: ComponentType<Props> = ({ intent }) => {
  const style: CSSProperties = {
    background: intent === 'unsaved' ? 'orange' : 'red',
    borderRadius: '.5em',
    display: 'inline-block',
    fontSize: '.8em',
    fontWeight: 'bold',
    lineHeight: '1.5em',
    padding: '0 .5em',
    textTransform: 'uppercase',
  };

  return (
    <div style={{ display: 'block', marginTop: '.5em' }}>
      <span style={style}>{MESSAGES[intent]}</span>
    </div>
  );
};
